class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    // if(document.querySelector('.ctn-product-free')){
    //   this.addProductFree()
    // }
    document.body.style.overflowY = 'hidden';
  }

  //  getQtyShoes = async ()=> {
  //   let qtyShoes = 0;
  //   let qtyFreeProduct = 0;
  //   let VariantsFree = []
  //   const cartData = await fetch('/cart.json').then(res =>{
  //     return res.json()
  //   }).catch(err=>{
  //     console.log(err)
  //   });
    
  //   for (const item of cartData.items) {
  //     const product = await fetch(`${window.Shopify.routes.root}products/${item.handle}.js`)
  //       .then(response => response.json()).catch(err => console.log(err));
      
  //     product.tags.forEach(tag => {
  //       if (tag === "CALZADO") {
  //         qtyShoes += item.quantity;
  //       }
  //     });
  //     product.tags.forEach(tag => {
  //       if (tag === "CHARMS_FREE") {
  //         qtyFreeProduct += item.quantity;
  //         VariantsFree.push({id:item.variant_id, qty:item.quantity});
  //       }
  //     });
  //   }
    
  //   return [qtyShoes, qtyFreeProduct, VariantsFree];
  // }

  // async addProductFree(){
  //     const buttonsConfirm = document.querySelector("#confirmSelection")
  //     buttonsConfirm.disabled = true
  //     buttonsConfirm.style.opacity = 0.5
  //     const variantsSlide = document.querySelectorAll(".variant-slide")
  //     variantsSlide.forEach(slide => {
  //       slide.classList.add("disabled")
  //     })
  //     let [qtyShoes, qtyFreeProduct, VariantsFree] = await this.getQtyShoes()
  //     buttonsConfirm.disabled = false
  //     buttonsConfirm.style.opacity = 1
  //     variantsSlide.forEach(slide => {
  //       slide.classList.remove("disabled")
  //     })
  //     if(qtyShoes == 0) return
  //     const selectedVariants = new Set();
  //     const maxSelection = qtyShoes * 3;
  //     const quantitySelected = document.querySelectorAll('.selected-variants')
  //     quantitySelected.forEach(qty =>{
  //       qty.textContent = `${selectedVariants.size}/${maxSelection}`
  //     })
  //     // Manejar la selección de slides
  //     document.querySelectorAll(".variant-slide").forEach(slide => {
  //       VariantsFree.forEach(variantFree =>{
  //         if(variantFree.id == slide.getAttribute("data-variant-id")){
  //           selectedVariants.add(slide.getAttribute("data-variant-id"));
  //           // slide.classList.add("selected");
  //           slide.querySelector('img').classList.add("selected")
  //         }
  //       })
  //       slide.addEventListener("click", function () {
  //         const variantId = this.getAttribute("data-variant-id");
  //         // Si ya está seleccionado
  //         if (selectedVariants.has(variantId)) {
  //           selectedVariants.delete(variantId);
  //           // this.classList.remove("selected");
  //           slide.querySelector('img').classList.remove("selected")
  //         } 
  //         // Si no está seleccionado
  //         else if (selectedVariants.size < maxSelection) {
  //           selectedVariants.add(variantId);
  //           this.classList.add("selected");
  //           slide.querySelector('img').classList.add("selected")
  //         }
    
  //         // Si ya hemos seleccionado 2 variantes
  //         if (selectedVariants.size >= maxSelection) {
  //           document.querySelectorAll(".variant-slide").forEach(slide => {
  //             if (!selectedVariants.has(slide.getAttribute("data-variant-id"))) {
  //               slide.classList.add("disabled"); // Deshabilitar el resto de las opciones
  //             }
  //           });
  //         } else {
  //           // Si no hemos alcanzado el límite, habilitamos todas las opciones
  //           document.querySelectorAll(".variant-slide").forEach(slide => {
  //             slide.classList.remove("disabled");
  //           });
  //         }
  //         quantitySelected.forEach(qty =>{
  //           qty.textContent = `${selectedVariants.size}/${maxSelection}`
  //         })
  //       });
  //     });
  //     if (selectedVariants.size >= maxSelection) {
  //       document.querySelectorAll(".variant-slide").forEach(slide => {
  //         if (!selectedVariants.has(slide.getAttribute("data-variant-id"))) {
  //           slide.classList.add("disabled"); // Deshabilitar el resto de las opciones
  //         }
  //       });
  //     } else {
  //       // Si no hemos alcanzado el límite, habilitamos todas las opciones
  //       document.querySelectorAll(".variant-slide").forEach(slide => {
  //         slide.classList.remove("disabled");
  //       });
  //     }
  //     quantitySelected.forEach(qty =>{
  //       qty.textContent = `${selectedVariants.size}/${maxSelection}`
  //     })
  //     // Al hacer clic en el botón de confirmar
  //     document.querySelectorAll("#confirmSelection").forEach(button =>{
  //       button.addEventListener("click",() =>{

  //       })
  //     })
  //     document.getElementById("confirmSelection").addEventListener("click", function (e) {
  //       e.preventDefault();
  //       if(maxSelection < selectedVariants.size) return
  //       if (selectedVariants.size > 0) {
  //         buttonsConfirm.disabled = true
  //         buttonsConfirm.style.opacity = 0.5
  //         const data = []
  //         const idsSelected = Array.from(selectedVariants)
  //         idsSelected.forEach(id => {
  //           if(VariantsFree.length){
  //             const existsInVariantsFree = VariantsFree.some(item => item.id == id);
  //             if (true) {
  //               data.push({ id: id, quantity: 1 });
  //             }
  //           }else{
  //             data.push({id: id, quantity:1})
  //           }
  //         });
  //         let formData = new FormData();
  //             VariantsFree.forEach((variant) =>{
  //               formData.append(`updates[${variant.id}]`, 0);
  //             })
  //             if(VariantsFree.length){
  //                 fetch('/cart/update.js', {
  //                   method: 'POST',
  //                   body: formData
  //                 })
  //                 .then(response => response.json())
  //                 .then(result => {
  //                   if(result.status > 400){
  //                     return
  //                   }
  //                   fetch('/cart/add.js', {
  //                     method: 'POST', 
  //                     headers: {
  //                       'Content-Type': 'application/json',
  //                       'X-Requested-With': 'XMLHttpRequest'
  //                     },
  //                     body: JSON.stringify({
  //                       items: data,
  //                       sections: 'cart-icon-bubble'
  //                     })
  //                   })
  //                   .then(response => response.json())
  //                   .then(result => {      
  //                     if(result.status > 400){
  //                       return
  //                     }
  //                     location.href = '/cart'
                      
  //                   })
  //                   .catch(error => {
  //                     console.log(error)            
  //                   }).finally(() =>{
  //                   })
  //                 })
  //                 .catch(error => {
  //                   console.log(error)      
  //                   buttonsConfirm.disabled = false
  //                   buttonsConfirm.style.opacity = 1      
  //                 }).finally(() =>{
  //               })
  //             }else{
  //               fetch('/cart/add.js', {
  //                   method: 'POST', 
  //                   headers: {
  //                     'Content-Type': 'application/json',
  //                     'X-Requested-With': 'XMLHttpRequest'
  //                   },
  //                   body: JSON.stringify({
  //                     items: data,
  //                     sections: 'cart-icon-bubble'
  //                   })
  //                 })
  //                 .then(response => response.json())
  //                 .then(data => {      
  //                   if(data.status > 400){
  //                     return
  //                   }
  //                   location.href = '/cart'
                    
  //                 })
  //                 .catch(error => {
  //                   buttonsConfirm.disabled = false
  //                   buttonsConfirm.style.opacity = 1
  //                   console.log(error)            
  //                 }).finally(() =>{
  //                 })
  //             }

  //       } else {
  //         console.log("selecciona")
  //       }
  //     });
  // }
  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    document.body.style.overflowY = 'auto';
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
